import React from "react"

import { Button } from "reactstrap"

import { usePrefs } from "../../contexts/PreferencesContext"

import MDBModal from "./MDBModal"

const PreferencesForm = ({show, dismiss}) => {

    const { patientStatusDisplay, setPref } = usePrefs()

    const handleInputChange = (event) => {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name
        setPref(name, value)
    }

    const radioChangeHandler = (event) => {
        const name = event.currentTarget.name
        const val = event.currentTarget.value
        setPref(name, val)
    }

    return (
        <MDBModal
            title="User Preferences"
            show={show}
            dismiss={dismiss}
        >
            <div className="container">
                <div className="row">
                    <h3>Patient Status Display</h3>
                    <br/>
                    <label>
                        &nbsp;
                        <input
                            type="radio"
                            name="patientStatusDisplay"
                            value="navbar"
                            checked={patientStatusDisplay === "navbar"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Top Nav Bar &nbsp;
                    </label>
                    <label>
                        &nbsp;
                        <input
                            type="radio"
                            name="patientStatusDisplay"
                            value="leftColumn"
                            checked={patientStatusDisplay === "leftColumn"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Left Column &nbsp;
                    </label>

                </div>
                {/* <div className="row">
                    <h5>Intervention List Style</h5>
                    <br/>
                    <label>
                        &nbsp;
                        <input
                            type="radio"
                            name="intvListStyle"
                            value="tabs"
                            checked={intvListStyle === "tabs"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Tabs &nbsp;
                    </label>
                    <label>
                        &nbsp;
                        <input
                            type="radio"
                            name="intvListStyle"
                            value="vert-tabs"
                            checked={intvListStyle === "vert-tabs"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Vertical Tabs &nbsp;
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="intvListStyle"
                            value="accordian"
                            checked={intvListStyle === "accordian"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Accordian &nbsp;
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="intvListStyle"
                            value="dropdown"
                            checked={intvListStyle === "dropdown"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Dropdown
                    </label>
                </div> */}
                {/* <div className="row">
                    <h5>Head-to-toe Style</h5>
                    <br />

                    <label>
                        <input
                            type="radio"
                            name="headToToeStyle"
                            value="stick-figure"
                            checked={headToToeStyle === "stick-figure"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Stick Figure &nbsp;
                    </label>
                    <label>
                        <input
                            type="radio"
                            name="headToToeStyle"
                            value="nav"
                            checked={headToToeStyle === "nav"}
                            onChange={radioChangeHandler}
                        />
                        &nbsp; Nav &nbsp;
                    </label>
                </div> */}

                <Button
                    type="button"
                    className="btn btn-success"
                    onClick={dismiss}
                >
                    Dismiss
                </Button>
            </div>
        </MDBModal>
    )
}

export default PreferencesForm